import ConsoleApi from "@/consoleapi/consoleApi";
import {AxiosResponse} from "axios";

/**
 *
 */
export default class RestcommApplications extends ConsoleApi {
    protected resource = '/restcomm/applications';

    /**
     * @param accountId
     * @param applicationSid
     */
    public find(accountId: string, applicationSid: string): Promise<AxiosResponse>{
        return this.axios.get(this.requestUri + this.getAccountResource(accountId) + '/' + applicationSid, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    public get(accountId: string): Promise<AxiosResponse>{
        return this.axios.get(this.requestUri + this.getAccountResource(accountId), {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param applicationName
     * @param referenceRcmlUrl
     */
    public create(accountId: string, applicationName: string, referenceRcmlUrl: string): Promise<AxiosResponse>{
        return this.axios.post(this.requestUri + this.getAccountResource(accountId), {
            'FriendlyName':applicationName,
            'RcmlUrl':referenceRcmlUrl,
            'Kind': 'voice',
        },{
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    public createRVD(accountId: string, applicationName: string): Promise<AxiosResponse>{
        return this.axios.post(this.requestUri + this.getAccountResource(accountId), {
            'FriendlyName':applicationName,
            'Kind': 'rvd',
        },{
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param applicationSid
     * @param applicationName
     * @param referenceRcmlUrl
     */
    public update(accountId: string, applicationSid: string , applicationName: string | null, referenceRcmlUrl: string | null): Promise<AxiosResponse>{
        return this.axios.put(this.requestUri + this.getAccountResource(accountId) + '/' + applicationSid, {
            'FriendlyName':applicationName,
            'RcmlUrl':referenceRcmlUrl,
        },{
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    public delete(accountId: string, applicationSid: string): Promise<AxiosResponse>{
        return this.axios.delete(this.requestUri + this.getAccountResource(accountId) + '/' + applicationSid, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }
}